import React from 'react';
import { ListProvider } from './list-context';
import { ClearAllButton } from './clear-all-button';
import styles from './styles.module.css';
import { useList } from './use-list';
/**
 * Компонент `<List />` необходим для создания связанных между собой элементов.
 * Списки могут быть как элементами навигации,
 * так и предоставлять возможность выбора из одного или многих элементов.
 * Можно определять секции и группировать элементы по смыслу, используя компонент
 * `<ListSection />`
 *
 * @example ``` tsx
 *  <List>
       <ListItem text='Иван' value="id_1"/>
       <ListItem text='Марья' value="id_2"/>
       <ListItem text="Алеша" value="id_3"/>
    </List>
 * ```
 * @param {ListProps} props
 * @constructor
 */
export function List(props) {
  const {
    children,
    listProviderValue,
    resetButton,
    listAttributes
  } = useList(props);
  return /*#__PURE__*/React.createElement(ListProvider, {
    value: listProviderValue
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.list,
    ...listAttributes
  }, resetButton && /*#__PURE__*/React.createElement(ClearAllButton, {
    ...resetButton
  }), children));
}